import { activate } from './user/activate'

export const users = {
  add: 'Add user',
  title: 'Users',
  default2FATitle: 'Default 2FA method',
  add2FA: 'Add',
  delete2Fa: 'Remove',
  default2FADescription: 'Select the default 2FA method for new users',
  defaultMethod: 'Default method',
  chosePreferred2FAMethod:
    'Choose your preferred two-factor authentication (2FA) method. You can change this option at any time.',
  twoFactorMethods: '2FA Methods',
  authenticator: 'Authenticator app',
  authenticatorDescription:
    'Authenticator app (e.g., Google Authenticator, Authy)',
  codeSend: 'Send code',
  emailDescription: 'A code will be sent to your email address',
  configured: 'Configured',
  updatedUser: 'User has been updated',
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Email',
  roles: 'Role',
  createdUser: 'User has been created',
  searchTable: 'Search',
  showInactive: 'Show inactive',
  showInactiveOnly: 'Show only inactive',
  addUser: 'Add user',
  editUser: 'Edit user',
  statusUser: 'Edit user status',
  deActivateUser: 'Deactivate user account',
  activateUser: 'Activate user account',
  changedStatus: 'User status has been changed',
  resendMailSuccess: 'Activation email has been resent',
  roleChoice: 'Choose role',
  emailConfirmCode: 'Confirm with email code',
  passwordConfirm: 'Confirm with password',
  authenticatorConfirm: 'Confirm with authenticator app code',
  emailConfirmCodeRequired: 'Confirmation with code from email is required',
  passwordConfirmRequired: 'Confirmation with password is required',
  authenticatorConfirmRequired:
    'Confirmation with code from authenticator app is required',
  no2FAMethods: 'No two-factor authentication methods configured',
  tooltips: {
    edit: 'Edit user',
    resendMail: 'Resend email',
    delete: 'Delete user',
  },
  delete: {
    deleteUser: 'Delete user',
    deleteUserConfirm: 'Are you sure you want to delete this user?',
    deletedUserSuccess: 'User has been deleted',
  },
  disabledEditBaseRole: 'The base role cannot be edited or deleted.',
  activate: activate,
  confirmEmailChange: {
    loading: 'Confirming your email change',
    success: 'Your email address has been changed. Please log in again.',
    invalidOrExpired:
      'This link has expired or is invalid. Please request the email change again.',
    emailAlreadyTaken: 'This email address is already taken.',
    missingParams: 'Invalid link',
    goToLogin: 'Go to login',
  },
  pendingEmailChange: {
    badge: 'Change pending',
    message: 'Change to {email} is pending confirmation',
    created:
      'We sent a confirmation link to {email}. The change will take effect once it is clicked (the link is valid until {expiresAt}).',
    cancelled: 'The pending email change has been cancelled.',
    cancelAction: 'Cancel change',
  },
}
